export default "__VITE_ASSET__DbCTiMAP__"